import CloseIcon from '@mui/icons-material/Close';
import { Box, Fade, Grid, IconButton, Modal, Typography } from '@mui/material';
import { Link } from '@tanstack/react-router';
import Menu from 'assets/icons/edit-note.svg?react';
import Logo from 'assets/icons/logo.svg?react';
import { RoutePaths } from 'common-types';
import { Notes } from 'components/notes';
import { Recent } from 'components/recent';
import { memo } from 'react';
import { useStore } from 'store';
import { useShallow } from 'zustand/shallow';

import CrownIcon from './assets/crown.svg?react';

export const HeaderLanding = memo(() => {
  const { isModalOpened } = useStore(
    useShallow((state) => ({
      isModalOpened: state.isModalOpened,
    })),
  );

  const handleNavigateToPayment = (): void => {
    useStore.getState().paymentRef?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleOpenModal = (): void => {
    useStore.getState().setIsModalOpened(true);
  };

  const handleCloseModal = (): void => {
    useStore.getState().setIsModalOpened(false);
  };

  return (
    <>
      <Box
        component="header"
        position="fixed"
        top={0}
        left={0}
        px={4}
        width="100%"
        py={2.5}
        zIndex={3}
        bgcolor="common.white"
      >
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid>
            <Grid container>
              <Box component={Link} to={RoutePaths.HOME}>
                <Logo />
              </Box>
            </Grid>
          </Grid>
          <Grid>
            <Grid container alignItems="center" gap={3.5}>
              <Grid container sx={{ flexGrow: 1 }}>
                <CrownIcon />
              </Grid>
              <Grid>
                <Box
                  role="button"
                  px={5}
                  py={1.5}
                  bgcolor="custom.orange"
                  borderRadius={1.5}
                  onClick={handleNavigateToPayment}
                >
                  <Typography variant="body1" component="span" fontWeight={500} color="common.white">
                    Premium
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid>
            <Grid container>
              {isModalOpened ? (
                <IconButton onClick={handleCloseModal} sx={{ p: 0, color: 'common.black' }}>
                  <CloseIcon />
                </IconButton>
              ) : (
                <IconButton onClick={handleOpenModal} sx={{ p: 0 }}>
                  <Menu />
                </IconButton>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Fade in={isModalOpened} timeout={500}>
        <Modal open={isModalOpened} keepMounted onClose={handleCloseModal} sx={{ zIndex: 2 }}>
          <Grid
            container
            direction="column"
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            py={10}
            bgcolor="common.white"
          >
            <Grid>
              <Notes />
            </Grid>
            <Grid sx={{ mt: 'auto' }}>
              <Recent />
            </Grid>
          </Grid>
        </Modal>
      </Fade>
    </>
  );
});
